import { useMemo, useState } from 'react';
import { feedCards } from '@/mocks/gossip';
import SectionHead from './SectionHead';

const cats = ['全部', '关联事件', '同类型瓜', '历史对比', '人物关系', '幕后关联'];

export default function FeedSection() {
  const [cat, setCat] = useState('全部');
  const [kw, setKw] = useState('');

  const list = useMemo(() => {
    const key = kw.trim().toLowerCase();
    return feedCards.filter((c) => {
      const okCat = cat === '全部' || c.cat === cat;
      const okKw = !key || c.title.toLowerCase().includes(key) || c.desc.toLowerCase().includes(key);
      return okCat && okKw;
    });
  }, [cat, kw]);

  return (
    <section id="feed" className="scroll-mt-28 py-12 md:py-16 bg-background-100/60">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          kicker="LATEST FIELD"
          kickerZh="编辑部一手跟进"
          title="最新瓜田：实时更新的延伸阅读"
          desc="每一条都从热搜出发，串联关联事件、同类型瓜、人物关系与幕后信息，配齐延伸阅读。可按栏目筛选，也可直接搜索你关心的人或事件。"
        />

        {/* toolbar */}
        <div className="mb-6 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
          <div className="custom-scroll flex gap-2 overflow-x-auto pb-1">
            {cats.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setCat(c)}
                className={`shrink-0 rounded-full px-4 py-1.5 text-sm whitespace-nowrap transition-colors ${
                  cat === c
                    ? 'bg-foreground-950 text-background-50 font-semibold'
                    : 'border border-background-200 bg-background-50 text-foreground-600 hover:border-foreground-300'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <label className="relative w-full lg:w-80">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400"></i>
            <input
              type="search"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜索事件、人物或关键词…"
              aria-label="搜索事件"
              className="w-full rounded-md border border-background-200 bg-background-50 py-2.5 pl-11 pr-4 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
            />
          </label>
        </div>

        {list.length === 0 ? (
          <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-background-300 bg-background-50 py-20 text-center">
            <i className="ri-emotion-sad-line text-5xl text-secondary-400"></i>
            <p className="mt-4 text-sm text-foreground-600">暂时没有找到匹配的内容，换个关键词试试？</p>
            <button
              type="button"
              onClick={() => {
                setKw('');
                setCat('全部');
              }}
              className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 whitespace-nowrap hover:bg-primary-600"
            >
              <i className="ri-restart-line"></i>
              重置筛选
            </button>
          </div>
        ) : (
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((c) => (
              <a
                key={c.id}
                href="#deep"
                className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={c.img}
                    alt={`${c.title}延伸阅读配图`}
                    className="h-48 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-primary-700 whitespace-nowrap">
                    {c.live ? <i className="ri-record-circle-line text-primary-500 animate-pulse-dot"></i> : null}
                    {c.cat}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 line-clamp-2">
                    {c.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-6 text-foreground-600 line-clamp-2">{c.desc}</p>
                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-time-line"></i>
                      {c.meta}
                    </span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line"></i>
                      {c.comments}
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}